var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn-toggle',{attrs:{"tile":"","group":"","mandatory":""},model:{value:(_vm.emailClient),callback:function ($$v) {_vm.emailClient=$$v},expression:"emailClient"}},[_c('v-btn',{attrs:{"small":"","value":"mailto"}},[_vm._v(" Mail-App ")]),_c('v-btn',{attrs:{"small":"","value":"outlook"}},[_vm._v(" Outlook Web ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }